import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import ApplicantReviewCarousel from 'v1/components/feature/CalloutComponents/Callout/ApplicantReviewCarousel/ApplicantReviewCarousel';
import ApplicantReviewActions from 'v1/components/feature/CalloutComponents/Callout/ApplicantReviewActions/ApplicantReviewActions';
import { ModalWrapper, ModalContent } from 'v1/components/shared';

import { applicantsFilters } from 'v1/helpers/byModel/applicantHelper';
import get from 'lodash/get';
import findIndex from 'lodash/findIndex';
import isEmpty from 'lodash/isEmpty';
import { chain } from 'lodash';
import ModalHeader from 'modals/layout/ModalHeader/ModalHeader';

import './ApplicantReviewModal.scss';

const ApplicantReviewModal = () => {
  const { calloudId, applicantId, filter } = useSelector(
    state => state.ui.data
  );

  const callout = useSelector(state =>
    get(state.callouts, ['data', calloudId], {})
  );

  const applicants = useSelector(state =>
    chain(
      get(state.callouts, ['associations_data', calloudId, 'applicants'], [])
    )
      .filter(applicantsFilters[filter])
      .value()
  );

  const [selectedApplicantIndex, setSelectedApplicantIndex] = useState(
    findIndex(applicants, a => a.id === applicantId)
  );

  useEffect(() => {
    // If applicants list has changed and selectedApplicant is empty select next available applicant
    if (!isEmpty(applicants) && isEmpty(applicants[selectedApplicantIndex])) {
      setSelectedApplicantIndex(0);
    }
  }, [applicants]);

  function onNavigate(direction) {
    let newIndex = 0;
    if (direction === 'LEFT') {
      newIndex =
        selectedApplicantIndex === 0
          ? applicants.length - 1
          : selectedApplicantIndex - 1;
    }
    if (direction === 'RIGHT') {
      newIndex =
        selectedApplicantIndex === applicants.length - 1
          ? 0
          : selectedApplicantIndex + 1;
    }
    setSelectedApplicantIndex(newIndex);
  }

  return (
    <ModalWrapper className="ApplicantReviewModal" size="M">
      <ModalHeader title="Review applicants" />
      <ModalContent>
        <ApplicantReviewCarousel
          selectedApplicant={applicants[selectedApplicantIndex]}
          callout={callout}
        />
        <ApplicantReviewActions
          applicants={applicants}
          selectedApplicant={applicants[selectedApplicantIndex]}
          callout={callout}
          onNavigate={onNavigate}
        />
      </ModalContent>
    </ModalWrapper>
  );
};

export default ApplicantReviewModal;
